/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GpsFixPayload
 */
export interface GpsFixPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: GpsFixPayloadTypeEnum;
    /**
     * 
     */
    hasFix: boolean;
    /**
     * 
     */
    latitude?: number | null;
    /**
     * 
     */
    longitude?: number | null;
    /**
     * 
     */
    lastValidFixTime?: number | null;
}


/**
 * @export
 */
export const GpsFixPayloadTypeEnum = {
    GpsFix: 'gps_fix',
} as const;
export type GpsFixPayloadTypeEnum = typeof GpsFixPayloadTypeEnum[keyof typeof GpsFixPayloadTypeEnum];


/**
 * Check if a given object implements the GpsFixPayload interface.
 */
export function instanceOfGpsFixPayload(value: object): value is GpsFixPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'gps_fix') return false;
    
    if ((!('hasFix' in (value as Record<string, any>)) && !('has_fix' in (value as Record<string, any>))) || ((value as Record<string, any>)['hasFix'] === undefined && (value as Record<string, any>)['has_fix'] === undefined)) return false;
    return true;
}

export function GpsFixPayloadFromJSON(json: any): GpsFixPayload {
    return GpsFixPayloadFromJSONTyped(json, false);
}

export function GpsFixPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): GpsFixPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'hasFix': json['has_fix'],
        'latitude': json['latitude'] === undefined ? undefined : json['latitude'] === null ? null : json['latitude'],
        'longitude': json['longitude'] === undefined ? undefined : json['longitude'] === null ? null : json['longitude'],
        'lastValidFixTime': json['last_valid_fix_time'] === undefined ? undefined : json['last_valid_fix_time'] === null ? null : json['last_valid_fix_time'],
    };
}

export function GpsFixPayloadToJSON(json: any): GpsFixPayload {
    return GpsFixPayloadToJSONTyped(json, false);
}

export function GpsFixPayloadToJSONTyped(value?: GpsFixPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'has_fix': value['hasFix'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'last_valid_fix_time': value['lastValidFixTime'],
    };
}

